// components/HomeHeroSkeleton.jsx
const HomeHeroSkeleton = () => (
  <div className="relative min-h-[90vh] flex items-center overflow-hidden bg-gradient-to-br from-green-50 via-white to-green-100">
    <div className="container mx-auto px-4">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          {/* Title skeleton */}
          <div className="h-16 bg-gradient-to-r from-green-200 to-emerald-200 rounded-xl mb-6 w-3/4 skeleton"></div>
          
          {/* Subtitle skeleton */}
          <div className="h-6 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg mb-8 w-full skeleton"></div>
          <div className="h-6 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg mb-8 w-5/6 skeleton"></div>
          
          {/* CTA buttons skeleton */}
          <div className="flex flex-wrap gap-4 mb-12">
            <div className="w-40 h-14 bg-gradient-to-r from-green-300 to-emerald-300 rounded-full skeleton"></div>
            <div className="w-40 h-14 bg-white rounded-full skeleton"></div>
          </div>
          
          {/* Features skeleton */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="h-8 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg skeleton"></div>
            ))}
          </div>
        </div>
        
        {/* Image skeleton */}
        <div className="hidden lg:block">
          <div className="w-full h-[500px] bg-gradient-to-r from-green-200 to-emerald-200 rounded-3xl skeleton"></div>
        </div>
      </div>
    </div>
  </div>
);

export default HomeHeroSkeleton;